const talentTrainingRoutes = {
    name: 'talentTrainingLayout',
    path: '/talentTraining',
    component: () => import('@/layout/index.vue'),
    redirect: '/talentTrainingIndex',
    children: [
        {
            path: '/talentTrainingIndex',
            component: () => import('@/views/talentTraining/index.vue'),
            meta: {
                title: '人才培训'
            }
        },
        {
            path: '/bulletinList',
            component: () => import('@/views/talentTraining/bulletinList.vue'),
            meta: {
                title: '公告列表'
            }
        },
        {
            path: '/bulletinDetails',
            component: () => import('@/views/talentTraining/bulletinDetails.vue'),
            meta: {
                title: '公告详情'
            }
        },
        {
            path: '/enroll',
            component: () => import('@/views/talentTraining/enroll.vue'),
            meta: {
                title: '报名'
            }
        },
        {
            path: '/lecturer',
            component: () => import('@/views/talentTraining/lecturer.vue'),
            meta: {
                title: '讲师详情'
            }
        },
        {
            path: '/trainGraceList',
            component: () => import('@/views/talentTraining/trainGraceList.vue'),
            meta: {
                title: '培训风采'
            }
        }
    ]
}

const talentTrainingWhite = [
    {
		path: '/talentTraining'
	},
    {
		path: '/talentTrainingIndex'
	},
    {
		path: '/bulletinList'
	},
    {
		path: '/bulletinDetails'
	},
    {
		path: '/enroll'
	},
    {
        path: '/lecturer'
    },
    {
        path: '/trainGraceList'
    }
]

export {
    talentTrainingRoutes,
    talentTrainingWhite
}